import { HttpErrorResponse } from '@angular/common/http';

export interface ApiResponse<T> {
  success: boolean;
  message: string;
  data: T | null;
  errors?: unknown;
}

/** Only a successful analytics envelope may reach report components or cache. */
export function unwrapResponse<T>(body: ApiResponse<T>): T {
  if (!body || typeof body.success !== 'boolean' || typeof body.message !== 'string' || !Object.prototype.hasOwnProperty.call(body, 'data')) {
    throw new HttpErrorResponse({status: 502, error: {message: 'Unexpected analytics response. Please retry.'}});
  }
  if (!body.success || body.data == null) {
    throw new HttpErrorResponse({status: body.success ? 502 : 200, error: {
      message: body.message || 'Unable to load analytics. Please retry.', errors: body.errors,
    }});
  }
  return body.data;
}

/** Keep existing field-validation handling while exposing one readable message. */
export function normalizeApiError(error: HttpErrorResponse): HttpErrorResponse {
  const body = error.error;
  const message = typeof body?.message === 'string' ? body.message
    : typeof body?.detail === 'string' ? body.detail
    : error.status === 0 ? 'Unable to connect to analytics. Please retry.'
    : `Unable to load analytics (HTTP ${error.status}). Please retry.`;
  return new HttpErrorResponse({status: error.status, statusText: error.statusText, headers: error.headers,
    url: error.url || undefined,
    error: {...(body && typeof body === 'object' ? body : {}), ...(body?.errors && typeof body.errors === 'object' ? body.errors : {}), message, detail: message},
  });
}
